import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';
import { OiqSmsAlert } from './sms-alerts.service';

@Component({
  selector: 'oiq-notification-sms-alerts-list',
  templateUrl: './sms-alerts-list.component.html',
  styleUrls: ['../events/events-list.component.scss'],
})
export class OiqNotificationSmsAlertsListComponent {
  private static readonly PREVIEW_LENGTH = 120;

  @Input() items: OiqSmsAlert[] = [];
  /** false for users who cannot open fundings: rows only offer mark-as-read. */
  @Input() canOpen = true;
  @Output() event = new EventEmitter<{ type: 'open' | 'read'; data: OiqSmsAlert }>();

  getFormatFromNow(datetime: string) {
    return moment(datetime).fromNow();
  }

  preview(body: string): string {
    const max = OiqNotificationSmsAlertsListComponent.PREVIEW_LENGTH;
    return body.length > max ? `${body.slice(0, max).trimEnd()}…` : body;
  }
}
